import axios from '../../axios';
import { toast } from 'react-toastify';
import { ADD_BRAND, DELETE_BRAND, GET_BRAND, UPDATE_BRAND, GET_ONE_BRAND } from '../types';

export const getBrand = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/brand/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_BRAND,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // console.error("Failed to get Brand. Please try again. :", err);
   }
};

export const addBrand = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/brand/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_BRAND, payload: res.data.data });
         setTimeout(() => {
            toast.success('Brand added successfully!');
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.warn(err.response.data?.message);
         return;
      }
      // if (err.response.data.errors[0].message) {
      //    toast.error(err.response.data.errors[0].message);
      // }
      // toast.error('Failed to add Brand. Please try again. :', err);
   }
};

export const updateBrand = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/brand/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_BRAND, payload: res.data.data });

         setTimeout(() => {
            toast.success('Brand updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.warn(err.response.data?.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update brand. Please try again.');
   }
};

// Delete Brand
export const deleteBrand = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/brand/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_BRAND, payload: { id } });
         toast.success('Brand deleted successfully!');
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete brand. Please try again.');
   }
};

export const getSingleBrand = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/brand/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_BRAND, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
